import { Text } from "../../../../atoms/Text";

interface PercentCaptionProps {
  /** Whole percent, 0-100. */
  percent: number;
}

/**
 * Raw percentage next to a title or band label. No progress bars anywhere in
 * the ledger — inline bars made row heights ragged and band bars read as noise.
 */
export const PercentCaption = ({ percent }: PercentCaptionProps) => (
  <Text
    as="span"
    variant="inherit"
    color="secondary"
    className="shrink-0 whitespace-nowrap text-(length:--ledger-text-cell) leading-[1.66] tabular-nums"
  >
    {percent}%
  </Text>
);
